import Component from "../../component";

export default class MobileNavigation extends Component{

    ready() {
        const hamburgerMenuButton = this.component.querySelector('.js-hamburger-menu-button');
        const hamburgerMenu = this.component.querySelector('.js-hamburger-menu');
        const mobileNavigation = this.component.querySelector('.js-mobile-navigation');

        window.addEventListener("changeHeaderTypeEvent", function(evt) {
            if(mobileNavigation.classList.contains('active')) {
                mobileNavigation.classList.toggle('active');
                hamburgerMenu.classList.toggle('active');
            }
        }, false);

        hamburgerMenuButton.addEventListener('click', el => {
            mobileNavigation.classList.toggle('active');
            hamburgerMenu.classList.toggle('active');
        });
    }

}